export const OpTypeNames = {
  1: "MobileRecharge",
  2: "MobilePostpaid",
  3: "DTH",
  4: "Broadband/Landline",
  5: "Electricity",
  6: "PipedGas",
  14: "MoneyTransfer",
  16: "Broadband",
  17: "Water",
  25: "LoanRepayment",
  26: "BookCylinder",
  27: "InsurancePremium",
  37: "AddMoney",
  38: "FastagRecharge",
  39: "CableTV",
  46: "MunicipalTaxes",
  47: "EducationFees",
  48: "HousingSociety",
  49: "CreditCard",
  50: "UPI",
  52: "Hospital",
  54: "Subscription",
  62: "UpiPayment",
  64: "ClubsandAssociations",
  69: "BARAssociationFee",
  70: "GooglePlay",
  83: "Advertisement",
  91: "Challan",
  92: "RecurringDeposit",
  112: "MunicipalServices",
};
export const SERVICE_ICONS = {
  MobileRecharge: "assets/pwa-static/pwa/images/svg/mobile.svg",
  MobilePostpaid: "assets/pwa-static/pwa/images/svg/postpaid.svg",
  DTH: "assets/pwa-static/pwa/images/svg/dth.svg",
  Electricity: "assets/pwa-static/pwa/images/svg/electricity.svg",
  "Broadband/Landline": "assets/pwa-static/pwa/images/svg/landline.svg",
  FastagRecharge: "assets/pwa-static/pwa/images/svg/fastag.svg",
  MunicipalTaxes: "assets/pwa-static/pwa/images/svg/municipal_taxes.svg",
  EducationFees: "assets/pwa-static/pwa/images/svg/education_fees.svg",
  HousingSociety: "assets/pwa-static/pwa/images/svg/housing_society.svg",
  CreditCard: "assets/pwa-static/pwa/images/svg/credit_card.svg",
  Hospital: "assets/pwa-static/pwa/images/svg/hospital.svg",
  PipedGas: "assets/pwa-static/pwa/images/svg/piped-gas.svg",
  GiftCards: "assets/pwa-static/pwa/images/svg/gift-cards.svg",
  Water: "assets/pwa-static/pwa/images/svg/water.svg",
  LoanRepayment: "assets/pwa-static/pwa/images/svg/loan_repayment.svg",
  Broadband: "assets/pwa-static/pwa/images/svg/broadband.svg",
  Subscription: "assets/pwa-static/pwa/images/svg/subscriptions.svg",
  GooglePlay: "assets/pwa-static/pwa/images/svg/google-play.svg",
  InsurancePremium: "assets/pwa-static/pwa/images/svg/insurance.svg",
  CableTV: "assets/pwa-static/pwa/images/svg/cable-tv.svg",
  ClubsandAssociations: "assets/pwa-static/pwa/images/svg/clubs.svg",
  BookCylinder: "assets/pwa-static/pwa/images/svg/LPG.svg",
  BARAssociationFee: "assets/pwa-static/pwa/images/svg/bar_association_fee.svg",
  Challan: "assets/pwa-static/pwa/images/svg/challan.svg",
  RecurringDeposit: "assets/pwa-static/pwa/images/svg/recurring_deposit.svg",
  MunicipalServices: "assets/pwa-static/pwa/images/svg/municipal_services.svg",
};

export const WALLET_TYPE = {
  isBalance: "Prepaid Wallet",
  isUBalance: "Utility Wallet",
  isBBalance: "Bank Wallet",
  isCBalance: " Card Wallet",
  isIDBalance: "RegID Wallet",
  isPacakgeBalance: "Package Wallet",
};
